const QUESTION_PREFIXES_EN = [
  'who',
  'what',
  'when',
  'where',
  'why',
  'how',
  'which',
  'whose',
  'whom',
  'can',
  'could',
  'would',
  'will',
  'should',
  'do',
  'does',
  'did',
  'is',
  'are',
  'am',
  'was',
  'were',
  'have',
  'has',
  'had',
  'may',
];

const QUESTION_PREFIXES_HE = [
  '\u05DE\u05D4',
  '\u05DE\u05D9',
  '\u05DE\u05EA\u05D9',
  '\u05D0\u05D9\u05E4\u05D4',
  '\u05D4\u05D9\u05DB\u05DF',
  '\u05D0\u05D9\u05DA',
  '\u05DB\u05DE\u05D4',
  '\u05DC\u05DE\u05D4',
  '\u05DE\u05D3\u05D5\u05E2',
  '\u05D0\u05D9\u05D6\u05D4',
  '\u05D0\u05D9\u05D6\u05D5',
  '\u05D0\u05D9\u05DC\u05D5',
  '\u05D4\u05D0\u05DD',
  '\u05D0\u05E4\u05E9\u05E8',
  '\u05E0\u05D9\u05EA\u05DF',
  '\u05EA\u05D5\u05DB\u05DC',
  '\u05EA\u05D5\u05DB\u05DC\u05D9',
  '\u05EA\u05D5\u05DB\u05DC\u05D5',
];

const QUESTION_LEAD_INS_EN = [
  'hi',
  'hello',
  'hey',
  'ok',
  'okay',
  'so',
  'well',
];

const QUESTION_LEAD_INS_HE = [
  '\u05D4\u05D9\u05D9',
  '\u05D4\u05D9',
  '\u05E9\u05DC\u05D5\u05DD',
  '\u05D0\u05D5\u05E7\u05D9\u05D9',
  '\u05D0\u05D5\u05E7\u05D9',
  '\u05D0\u05D6',
  '\u05D8\u05D5\u05D1',
];

const SHORT_QUESTION_PATTERNS_HE = [
  '\u05E9\u05D5\u05DE\u05E2',
  '\u05E9\u05D5\u05DE\u05E2\u05EA',
  '\u05E9\u05D5\u05DE\u05E2\u05D9\u05DD',
  '\u05DE\u05E7\u05E9\u05D9\u05D1',
  '\u05DE\u05E7\u05E9\u05D9\u05D1\u05D4',
  '\u05DE\u05D1\u05D9\u05DF',
  '\u05DE\u05D1\u05D9\u05E0\u05D4',
  '\u05E7\u05D5\u05DC\u05D8',
  '\u05E7\u05D5\u05DC\u05D8\u05EA',
  '\u05D0\u05D9\u05EA\u05D9',
];

const EXCLAMATION_PREFIXES_EN = [
  'wow',
  'whoa',
  'amazing',
  'awesome',
  'incredible',
  'unbelievable',
  'hurry',
  'help',
  'stop',
  'watch out',
];

const EXCLAMATION_PREFIXES_HE = [
  '\u05D5\u05D0\u05D5',
  '\u05D9\u05D5\u05D0\u05D5',
  '\u05DE\u05D3\u05D4\u05D9\u05DD',
  '\u05D0\u05D9\u05D6\u05D4 \u05D9\u05D5\u05E4\u05D9',
  '\u05E2\u05D6\u05E8\u05D4',
  '\u05E2\u05E6\u05D5\u05E8',
  '\u05EA\u05D9\u05D6\u05D4\u05E8',
  '\u05D3\u05D7\u05D5\u05E3',
];

const LIST_MARKERS_EN = [
  'one',
  'first',
  'two',
  'second',
  'three',
  'third',
  'four',
  'fourth',
  'five',
  'fifth',
  'six',
  'sixth',
  'seven',
  'seventh',
  'eight',
  'eighth',
  'nine',
  'ninth',
  'ten',
  'tenth',
];

const LIST_MARKERS_HE = [
  '\u05D0\u05D7\u05D3',
  '\u05D0\u05D7\u05EA',
  '\u05E8\u05D0\u05E9\u05D5\u05DF',
  '\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4',
  '\u05E9\u05EA\u05D9\u05D9\u05DD',
  '\u05E9\u05E0\u05D9\u05D9\u05DD',
  '\u05E9\u05E0\u05D9',
  '\u05E9\u05E0\u05D9\u05D4',
  '\u05E9\u05E0\u05D9\u05D9\u05D4',
  '\u05E9\u05DC\u05D5\u05E9',
  '\u05E9\u05DC\u05D5\u05E9\u05D4',
  '\u05E9\u05DC\u05D9\u05E9\u05D9',
  '\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA',
  '\u05D0\u05E8\u05D1\u05E2',
  '\u05D0\u05E8\u05D1\u05E2\u05D4',
  '\u05E8\u05D1\u05D9\u05E2\u05D9',
  '\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA',
  '\u05D7\u05DE\u05E9',
  '\u05D7\u05DE\u05D9\u05E9\u05D4',
  '\u05D7\u05DE\u05D9\u05E9\u05D9',
  '\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA',
  '\u05E9\u05E9',
  '\u05E9\u05D9\u05E9\u05D4',
  '\u05E9\u05D9\u05E9\u05D9',
  '\u05E9\u05D9\u05E9\u05D9\u05EA',
  '\u05E9\u05D1\u05E2',
  '\u05E9\u05D1\u05E2\u05D4',
  '\u05E9\u05D1\u05D9\u05E2\u05D9',
  '\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA',
  '\u05E9\u05DE\u05D5\u05E0\u05D4',
  '\u05E9\u05DE\u05D9\u05E0\u05D9',
  '\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA',
  '\u05EA\u05E9\u05E2',
  '\u05EA\u05E9\u05E2\u05D4',
  '\u05EA\u05E9\u05D9\u05E2\u05D9',
  '\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA',
  '\u05E2\u05E9\u05E8',
  '\u05E2\u05E9\u05E8\u05D4',
  '\u05E2\u05E9\u05D9\u05E8\u05D9',
  '\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA',
];

const TERMINAL_PUNCTUATION_RE = /[.!?\u2026]["')\]]*$/u;
const TRAILING_SEPARATOR_RE = /[\s,;:]+$/u;
const ENGLISH_LOWER_RE = /[a-z]/;

type SpokenPunctuationRule = {
  pattern: RegExp;
  replacement: string;
};

const SPOKEN_PUNCTUATION_RULES: SpokenPunctuationRule[] = [
  { pattern: /\b(question mark)\b/giu, replacement: '?' },
  { pattern: /\b(exclamation mark)\b/giu, replacement: '!' },
  { pattern: /\b(full stop)\b/giu, replacement: '.' },
  { pattern: /\b(period)\b/giu, replacement: '.' },
  { pattern: /\b(dot)\b/giu, replacement: '.' },
  { pattern: /\b(comma)\b/giu, replacement: ',' },
  { pattern: /\b(semicolon)\b/giu, replacement: ';' },
  { pattern: /\b(colon)\b/giu, replacement: ':' },
  { pattern: /\b(dash)\b/giu, replacement: ' - ' },
  { pattern: /\b(hyphen)\b/giu, replacement: '-' },
  { pattern: /\b(new line)\b/giu, replacement: '. ' },
  { pattern: /\b(next line)\b/giu, replacement: '. ' },
  { pattern: /\b(\u05E1\u05D9\u05DE\u05DF \u05E9\u05D0\u05DC\u05D4)\b/gu, replacement: '?' },
  { pattern: /\b(\u05E1\u05D9\u05DE\u05DF \u05E7\u05E8\u05D9\u05D0\u05D4)\b/gu, replacement: '!' },
  { pattern: /\b(\u05E0\u05E7\u05D5\u05D3\u05D4)\b/gu, replacement: '.' },
  { pattern: /\b(\u05E4\u05E1\u05D9\u05E7)\b/gu, replacement: ',' },
  { pattern: /\b(\u05E0\u05E7\u05D5\u05D3\u05EA\u05D9\u05D9\u05DD)\b/gu, replacement: ':' },
  { pattern: /\b(\u05E0\u05E7\u05D5\u05D3\u05D4 \u05E4\u05E1\u05D9\u05E7)\b/gu, replacement: ';' },
  { pattern: /\b(\u05DE\u05E7\u05E3)\b/gu, replacement: '-' },
  { pattern: /\b(\u05E7\u05D5 \u05DE\u05E4\u05E8\u05D9\u05D3)\b/gu, replacement: ' - ' },
  { pattern: /\b(\u05E9\u05D5\u05E8\u05D4 \u05D7\u05D3\u05E9\u05D4)\b/gu, replacement: '. ' },
];

function normalizeWhitespace(text: string): string {
  return text.replace(/\s+/g, ' ').trim();
}

function normalizeForDetection(text: string): string {
  return normalizeWhitespace(text).toLowerCase();
}

function startsWithAnyPhrase(text: string, phrases: string[]): boolean {
  return phrases.some((phrase) => text === phrase || text.startsWith(`${phrase} `));
}

function stripLeadingPhrases(text: string, phrases: string[]): string {
  let result = text;

  while (result) {
    const next = result.replace(/^[,.\-:;]+/u, '').trimStart();
    const matched = phrases.find((phrase) => next === phrase || next.startsWith(`${phrase} `));
    if (!matched) {
      return next;
    }

    result = next.slice(matched.length).trimStart();
  }

  return result;
}

function looksLikeShortHebrewQuestion(text: string): boolean {
  const normalized = normalizeForDetection(text);
  if (!normalized) return false;

  const words = normalized.split(' ').filter(Boolean);
  if (words.length === 0 || words.length > 3) return false;

  return SHORT_QUESTION_PATTERNS_HE.some((pattern) =>
    normalized === pattern ||
    normalized.startsWith(`${pattern} `) ||
    normalized.endsWith(` ${pattern}`),
  );
}

function looksLikeQuestion(text: string, locale: string): boolean {
  if (text.includes('?')) return true;

  let normalized = normalizeForDetection(text);
  if (!normalized) return false;

  if (locale === 'he') {
    normalized = stripLeadingPhrases(normalized, QUESTION_LEAD_INS_HE);
    return startsWithAnyPhrase(normalized, QUESTION_PREFIXES_HE)
      || looksLikeShortHebrewQuestion(normalized);
  }

  normalized = stripLeadingPhrases(normalized, QUESTION_LEAD_INS_EN);
  return startsWithAnyPhrase(normalized, QUESTION_PREFIXES_EN);
}

function looksLikeExclamation(text: string, locale: string): boolean {
  if (text.includes('!')) return true;

  const normalized = normalizeForDetection(text);
  if (!normalized) return false;

  if (/^[A-Z0-9\s]{4,}$/.test(text) && /[A-Z]/.test(text)) {
    return true;
  }

  if (locale === 'he') {
    return startsWithAnyPhrase(normalized, EXCLAMATION_PREFIXES_HE);
  }

  return startsWithAnyPhrase(normalized, EXCLAMATION_PREFIXES_EN);
}

function escapeRegex(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function applySpokenPunctuation(text: string): string {
  let result = text;

  for (const { pattern, replacement } of SPOKEN_PUNCTUATION_RULES) {
    result = result.replace(pattern, replacement);
  }

  result = result
    .replace(/\s+([,.;:!?])/g, '$1')
    .replace(/([,.;:!?])(?!\s|$)/g, '$1 ')
    .replace(/\s*-\s*/g, ' - ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  return result;
}

function countWords(text: string): number {
  return normalizeWhitespace(text).split(' ').filter(Boolean).length;
}

function splitSpokenListSegments(text: string, locale: string): string[] {
  const markers = locale === 'he' ? LIST_MARKERS_HE : LIST_MARKERS_EN;
  const markerPattern = markers.map(escapeRegex).join('|');
  const markerRe = new RegExp(`\\b(?:${markerPattern})\\b`, locale === 'he' ? 'gu' : 'giu');
  const matches = [...text.matchAll(markerRe)];

  if (matches.length < 2) {
    return [text];
  }

  const segments: string[] = [];
  let start = 0;

  for (let i = 1; i < matches.length; i++) {
    const nextIndex = matches[i].index ?? 0;
    const candidate = text.slice(start, nextIndex).trim();
    if (countWords(candidate) >= 4) {
      segments.push(candidate);
      start = nextIndex;
    }
  }

  const tail = text.slice(start).trim();
  if (tail) {
    segments.push(tail);
  }

  return segments.length > 1 ? segments : [text];
}

function punctuateSingleSegment(text: string, locale: string): string {
  const normalized = normalizeWhitespace(text);
  if (!normalized) return '';
  if (TERMINAL_PUNCTUATION_RE.test(normalized)) return normalized;

  const base = normalized.replace(TRAILING_SEPARATOR_RE, '');
  if (!base) return '';

  if (looksLikeQuestion(base, locale)) {
    return `${base}?`;
  }

  if (looksLikeExclamation(base, locale)) {
    return `${base}!`;
  }

  return `${base}.`;
}

function capitalizeEnglishSentenceStarts(text: string): string {
  if (!ENGLISH_LOWER_RE.test(text)) return text;

  let result = '';
  let shouldCapitalize = true;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];

    if (shouldCapitalize && /[a-z]/.test(ch)) {
      result += ch.toUpperCase();
      shouldCapitalize = false;
      continue;
    }

    result += ch;

    if (/[.!?]/.test(ch)) {
      shouldCapitalize = true;
      continue;
    }

    if (/\S/.test(ch) && !/["'([{]/.test(ch)) {
      shouldCapitalize = false;
    }
  }

  return result;
}

export function restoreSpeechPunctuation(text: string, locale: string): string {
  const normalized = normalizeWhitespace(applySpokenPunctuation(text));
  if (!normalized) return '';
  if (TERMINAL_PUNCTUATION_RE.test(normalized)) {
    return locale === 'en' ? capitalizeEnglishSentenceStarts(normalized) : normalized;
  }

  const segments = splitSpokenListSegments(normalized, locale);
  const punctuated = segments.map((segment) => punctuateSingleSegment(segment, locale)).join(' ');
  return locale === 'en' ? capitalizeEnglishSentenceStarts(punctuated) : punctuated;
}

export function prepareTextForTts(text: string, locale: string): string {
  return restoreSpeechPunctuation(normalizeWhitespace(text), locale);
}
